import { useState } from 'react';
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import Button from '../shared/Button';
import LabeledSelect from '../shared/LabeledSelect';
import View from '../shared/View';

import './WithdrawProgram.scss';
import ReactMarkdown from 'react-markdown';
import { Dialog, DialogTitle, DialogContent, Box } from '@mui/material';

export default function WithdrawProgram(props) {
    const [name] = useState(!!props?.app?.StudentName ? props.app.StudentName.split(' ')[0] : 'student');
    const [step, setStep] = useState(1);

    let viewTitle = t('WithdrawProgram.Title', {
        name: name,
    });

    let step1 = (
        <div className="withdraw-program-body">
            <div className="withdraw-program-instructions">{t('WithdrawProgram.Step1Instructions')}</div>

            <div>
                <LabeledSelect labelText={t('WithdrawProgram.SelectLabel')}></LabeledSelect>
            </div>

            <div className="add-info-row">
                <label for="add-info">{t('WithdrawProgram.AddInfoLabel')}</label>

                <textarea id="add-info"></textarea>
            </div>
        </div>
    );

    let step2 = (
        <div className="withdraw-program-body">
            <div className="withdraw-program-instructions">
                <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className="red"
                />
                {t('WithdrawProgram.Step2Instructions')}
            </div>

            <div>
                <span className="red">{t('WithdrawProgram.Step2Exclamation')}</span> {name}
            </div>

            <div>
                <ReactMarkdown>
                    {t('WithdrawProgram.Note', {
                        name: name,
                    })}
                </ReactMarkdown>
            </div>
        </div>
    );

    let handleSubmit = () => {
        if (step === 1) {
            setStep(2);
        } else if (typeof props.close === 'function') {
            props.close();
        } else {
            return;
        }
    };

    return (
        <View name="withdraw-program">
            <Dialog open={true}>
                <DialogTitle>{viewTitle}</DialogTitle>
                <DialogContent>
                    <Box>{step === 1 ? step1 : step2}</Box>
                    <Box>
                        <Button
                            useMui={true}
                            defaultText={t('General.Cancel')}
                            type="grey"
                            onClick={() => (typeof props.close === 'function' ? props.close() : null)}
                            interactive={false}
                        />
                        <Button
                            useMui={true}
                            defaultText={t('WithdrawProgram.SubmitButton')}
                            onClick={handleSubmit}
                            interactive={false}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
        </View>
    );
}
